import React, { FC, useContext } from "react";
import { Box, Spinner } from "@chakra-ui/react";
import LegacyCreateOrder from "@/pages/orders/create";
import { HomeownerRequestCreatePage } from "@/pages/orders/request-create";
import { ApplicationContext } from "@/context/ApplicationContext";

export const CreateOrderRoute: FC = () => {
  const { toggles, togglesLoading, togglesError } = useContext(ApplicationContext);

  if (togglesLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minH="320px">
        <Spinner />
      </Box>
    );
  }

  if (togglesError || !toggles?.enable_client_profile_on_orders) {
    return <LegacyCreateOrder />;
  }

  return <HomeownerRequestCreatePage />;
};
